import { fireToast } from "services/sweetAlertConfig";
import * as S from "./styles";
import { IOccurrence } from "interfaces/Occurrence";

type ReportTypeModalProps = {
  isOpen: boolean;
  occurrence: IOccurrence;
  onPdfButtonClick: (occurrence: IOccurrence) => Promise<void>;
  closeModal: () => void;
  onWordButtonClick: (occurrence: IOccurrence) => Promise<void>;
};

export function ReportTypeModal({
  isOpen,
  occurrence,
  closeModal,
  onPdfButtonClick,
  onWordButtonClick,
}: ReportTypeModalProps) {
  async function handleWordClick() {
    fireToast("Aguarde um momento, seu relatório está sendo baixado");
    await onWordButtonClick(occurrence);
    closeModal();
  }

  async function handlePdfClick() {
    fireToast("Aguarde um momento, seu relatório está sendo baixado");
    await onPdfButtonClick(occurrence);
    closeModal();
  }

  return isOpen ? (
    <S.Overlay onClick={closeModal}>
      <S.Content>
        <h2>Deseja exportar o relatório em qual formato?</h2>

        <button type="button" onClick={handleWordClick}>
          Formato Word
        </button>

        <button type="button" onClick={handlePdfClick}>
          Formato PDF
        </button>
      </S.Content>
    </S.Overlay>
  ) : null;
}
